<template>
  <div :class="'route-' + $route.name">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>
